module.exports = __webpack_public_path__ + "static/media/ems.0052eb4c.jpg";